/**
 * The API refuses a candidate's review of their own unfinished attempt (it
 * carries the answer key), so lists must not link there. Staff opening someone
 * else's running attempt is allowed and unaffected.
 */
export const canOpenResult = (
  result: { status: 'completed' | 'in_progress' | 'abandoned'; userId: string },
  viewerId: string,
): boolean => !(result.status === 'in_progress' && result.userId === viewerId);
